import React from 'react';
import Icon from '../../../components/AppIcon';

const TermsContent = () => {
  return (
    <div className="space-y-6 text-foreground">
      <section>
        <div className="flex items-center gap-2 mb-3">
          <Icon name="DollarSign" size={20} className="text-error" />
          <h2 className="text-lg font-bold text-error">1. NO RESPONSIBILITY FOR LOSS OF FUNDS</h2>
        </div>
        <div className="bg-error/5 border-l-4 border-error p-4 rounded">
          <p className="font-semibold mb-2">CRITICAL RISK DISCLOSURE:</p>
          <p className="text-sm leading-relaxed">
            BOLTPay, its operators, affiliates, and service providers <strong>ARE NOT RESPONSIBLE</strong> for any loss, 
            theft, unauthorized access, or disappearance of your cryptocurrency, digital assets, or funds. This includes but is not limited to:
          </p>
          <ul className="list-disc list-inside text-sm mt-2 space-y-1 ml-4">
            <li>Loss due to market volatility or price fluctuations</li>
            <li>Theft or hacking of your account or wallet</li>
            <li>Unauthorized transactions or fraudulent activity</li>
            <li>Technical failures, system outages, or network issues</li>
            <li>User error, including incorrect addresses or lost credentials</li>
            <li>Third-party service failures or blockchain network issues</li>
          </ul>
          <p className="text-sm mt-3 font-semibold">
            You assume ALL financial risk when using this platform. Cryptocurrency transactions are irreversible.
          </p>
        </div>
      </section>

      <section>
        <div className="flex items-center gap-2 mb-3">
          <Icon name="MessageCircleOff" size={20} className="text-warning" />
          <h2 className="text-lg font-bold text-warning">2. NO CUSTOMER SUPPORT AVAILABLE</h2>
        </div>
        <div className="bg-warning/5 border-l-4 border-warning p-4 rounded">
          <p className="text-sm leading-relaxed">
            BOLTPay <strong>DOES NOT PROVIDE</strong> customer support, technical assistance, or account recovery services. 
            This means:
          </p>
          <ul className="list-disc list-inside text-sm mt-2 space-y-1 ml-4">
            <li>No email, phone, or chat support is available</li>
            <li>Lost passwords or private keys cannot be recovered</li>
            <li>Transaction disputes cannot be mediated or reversed</li>
            <li>Technical issues will not receive assistance</li>
            <li>Account access problems are your sole responsibility</li>
          </ul>
          <p className="text-sm mt-3 font-semibold">
            You are solely responsible for maintaining access to your account and securing your credentials.
          </p>
        </div>
      </section>

      <section>
        <div className="flex items-center gap-2 mb-3">
          <Icon name="ShieldOff" size={20} className="text-error" />
          <h2 className="text-lg font-bold text-error">3. NO LIABILITY & CANNOT BE SUED</h2>
        </div>
        <div className="bg-error/5 border-l-4 border-error p-4 rounded">
          <p className="text-sm leading-relaxed">
            By using BOLTPay, you agree that BOLTPay, its owners, operators, employees, and affiliates 
            <strong> CANNOT BE HELD LIABLE</strong> and <strong>CANNOT BE SUED</strong> for:
          </p>
          <ul className="list-disc list-inside text-sm mt-2 space-y-1 ml-4">
            <li>Any financial losses or damages of any kind</li>
            <li>Service interruptions, downtime, or unavailability</li>
            <li>Data breaches, security incidents, or privacy violations</li>
            <li>Errors, bugs, or defects in the platform</li>
            <li>Regulatory actions, legal compliance issues, or tax implications</li>
            <li>Third-party actions or failures</li>
          </ul>
          <p className="text-sm mt-3 font-semibold">
            You waive all rights to legal action, arbitration, or claims against BOLTPay. This includes class action lawsuits.
          </p>
        </div>
      </section>

      <section>
        <div className="flex items-center gap-2 mb-3">
          <Icon name="FileText" size={20} className="text-primary" />
          <h2 className="text-lg font-bold">4. GENERAL TERMS & CONDITIONS</h2>
        </div>
        <div className="bg-muted/50 border-l-4 border-primary p-4 rounded">
          <p className="text-sm leading-relaxed mb-3">
            <strong>Use at Your Own Risk:</strong> BOLTPay is provided "AS IS" without warranties of any kind, 
            express or implied. You use this service entirely at your own risk.
          </p>
          <p className="text-sm leading-relaxed mb-3">
            <strong>Regulatory Compliance:</strong> You are responsible for complying with all applicable laws, 
            regulations, and tax obligations in your jurisdiction.
          </p>
          <p className="text-sm leading-relaxed mb-3">
            <strong>Age Requirement:</strong> You must be at least 18 years old to use this service.
          </p>
          <p className="text-sm leading-relaxed mb-3">
            <strong>Prohibited Activities:</strong> You agree not to use BOLTPay for illegal activities, 
            money laundering, fraud, or any unlawful purpose.
          </p>
          <p className="text-sm leading-relaxed">
            <strong>Termination:</strong> BOLTPay reserves the right to terminate your account at any time 
            without notice or liability.
          </p>
        </div>
      </section>

      <section className="bg-primary/10 border-2 border-primary p-4 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-1" />
          <div>
            <p className="text-sm font-semibold mb-2">ACKNOWLEDGMENT OF UNDERSTANDING:</p>
            <p className="text-sm leading-relaxed">
              By proceeding, you confirm that you have read, understood, and agree to be bound by these terms. 
              You acknowledge that cryptocurrency transactions carry significant risk and that you are making 
              an informed decision to use this platform despite the disclaimers and limitations stated above.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsContent;